module.exports = __webpack_public_path__ + "static/partner_confregprova-b24058f3501ae20f3fc721c2b1f64474.svg";